import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { tabGroupError, tabGroupItems } from './tab-node-helpers';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const nextTabUiNodeSpec: NodeSpec<NodeCfg<'nextTab'>> = {
    nodeCategory: 'tab',
    kindLabel: 'Activate Next Tab',
    requiredSockets: [ 'trigger' ],
    controls: nodeCfg => ({
        tabGroupId: defineControlOpts({
            cfg: { kind: 'selection', label: 'Tab Group', items: tabGroupItems },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.tabGroupId,
        }),
    }),
    cfg: () => ({ id: getUID(), kind: 'nextTab', width: 220, controlValues: { tabGroupId: '' } }),
    inputs: () => ({ trigger: { socket: 'event', label: 'Trigger' } }),
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        activeTabIndex: { socket: 'number', label: 'Active Tab Number' },
    }),
    validator: node => {
        const error = tabGroupError(node.controlValues.tabGroupId);
        return error ? { tabGroupId: error } : true;
    },
};
